import {
  FETCH_ACTIVITY_LOG_PENDING,
  FETCH_ACTIVITY_LOG_SUCCEEDED,
  FETCH_ACTIVITY_LOG_FAILED,
} from '../constants/ActionTypes';

export const onFetchActivityLogPending = () => ({
  type: FETCH_ACTIVITY_LOG_PENDING,
});

export const onFetchActivityLogSucceeded = data => ({
  type: FETCH_ACTIVITY_LOG_SUCCEEDED,
  data,
});

export const onFetchActivityLogFailed = () => ({
  type: FETCH_ACTIVITY_LOG_FAILED,
});



// WEBPACK FOOTER //
// ./src/actions/ActivityLogActionCreators.js